import React from "react";

const LayoutContent = ({ children }) => {
  const useBgImage = Boolean(window.themes.use_background_image);
  const BgImage = window.themes.background_image_theme
    ? window.themes.background_image_theme
    : "";
  const bgColor = window.themes.background_color_theme
    ? window.themes.background_color_theme
    : "#000";
  const bgOpacity = window.themes.overlay_opacity;
  const bgImageStyle = {
    background: `linear-gradient(rgba(0, 0, 0, ${bgOpacity}), rgba(0, 0, 0, ${bgOpacity})), no-repeat
      url(${BgImage})`,
    backgroundSize: "cover"
  };
  const bgColorStyle = {
    background: `linear-gradient(rgba(0, 0, 0, ${bgOpacity}), rgba(0, 0, 0, ${bgOpacity}))`,
    backgroundColor: bgColor
  };
  const style = useBgImage ? bgImageStyle : bgColorStyle;

  return (
    <div className="layout-content" style={style}>
      {children}
    </div>
  );
};

export default LayoutContent;
